<template>
  <div class="recent-comments">
    <div class="columns">
      <div class="column is-12">
        <h2>
          {{ $t('recent_comments.recent_comments') }}
          <span class="close" @click="$emit('close')">
            <i class="icon icon-close"></i>
          </span>
        </h2>

        <div class="no-comments" v-if="comments !== false && comments.length <= 0">
          <img src="/images/sad.png">
          <p>{{ $t('recent_comments.no_recent_comments') }}</p>
        </div>

        <loading-indicator v-if="comments === false"></loading-indicator>

        <ul v-if="comments !== false && comments.length > 0">
          <comment v-for="comment in comments" :comment="comment" comment-type="excerpt" :key="comment.id" :show-avatar="false" :show-header="true"></comment>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import API from 'mixins/api';
  import Comment from './comment.vue';

  export default {
    mixins: [API],
    components: {
      Comment,
    },
    data() {
      return {
        Events: window.Events,
        comments: false
      }
    },
    beforeMount() {
      this.refreshComments();
      this.Events.$on('createComment', this.refreshComments);
    },
    methods: {
      refreshComments() {
        this.api().fetchRecentComments().then(comments => {
          this.comments = comments;
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "resources/assets/sass/layout/_variables";

.no-comments {
  margin-top: 100px;
  img {
    width: 40px;
    display: block;
    margin: 0 auto 20px;
  }
  p {
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 600;
    margin: 0 auto;
    text-align: center;
    letter-spacing: 1px;
  }
}

.recent-comments {
  width: 346.84px;
  margin-top: 38px;
  height: 100vh;
  border-left: 1px solid lighten($mutedblue, 12%);
  overflow: scroll;
  background: $white;
  padding: 56px 25px;
  position: fixed;
  right: 0;
  h2 {
    font-size: 14px;
    margin-bottom: 10px;
    width: 100%;
    .close {
      border: none;
      float: right;
      font-size: 16px;
      margin-top: -2px;
      color: $mutedblue;
      &:hover {
        cursor: pointer;
        color: $green;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// recent-comments.vue?5fb94e28